module.exports = __webpack_public_path__ + "img/first-login-close.3588017b.svg";